import { lazy } from "react";
import { Done } from "@material-ui/icons";

export const routes = [
  {
    name: "Center Management",
    customer: false,
    sub: "roles",
    icon: Done,
    path: "/center-management"
  },
  {
    name: "Customer Management",
    customer: false,
    sub: "roles",
    icon: Done,
    path: "/customer-management"
  },
  {
    name: "Users Management",
    customer: false,
    sub: "roles",
    icon: Done,
    path: "/user-management"
  },
  {
    name: "Roles Management",
    customer: false,
    sub: "roles",
    icon: Done,
    path: "/role-management"
  },
  {
    name: "Permission Management",
    customer: false,
    sub: "roles",
    icon: Done,
    path: "/permission-management"
  },
  {
    name: "Default Messages",
    customer: false,
    sub: "system",
    icon: Done,
    path: "/default-message"
  },
  {
    name: "Default",
    customer: false,
    sub: "system",
    icon: Done,
    path: "/default-email"
  }
];

export default [
  [
    {
      component: lazy(() => import("./views/SignIn")),
      link: "/sign-in"
    },
    {
      component: lazy(() => import("./views/Reset")),
      link: "/reset"
    },
    {
      component: lazy(() => import("./views/NewPassword")),
      link: "/reset/:token"
    }
  ],
  [
    {
      component: lazy(() => import("./views/Dashboard")),
      link: "/",
      customer: true
    },
    {
      component: lazy(() => import("./views/Account")),
      link: "/account",
      customer: true
    },
    {
      component: lazy(() => import("./views/SignUp")),
      link: "/sign-up",
      customer: false
    },
    {
      component: lazy(() => import("./views/UserManagement")),
      link: "/user-management",
      customer: false
    },
    {
      component: lazy(() =>
        import("./views/UserManagement/components/NewUser")
      ),
      link: "/new-user",
      customer: false
    },
    {
      component: lazy(() => import("./views/CustomerManagement")),
      link: "/customer-management",
      customer: false
    },
    {
      component: lazy(() =>
        import("./views/CustomerManagement/components/NewCustomer")
      ),
      link: "/new-customer",
      customer: false
    },
    {
      component: lazy(() => import("./views/CenterManagement")),
      link: "/center-management",
      customer: false
    },
    {
      component: lazy(() =>
        import("./views/CenterManagement/components/NewCenter")
      ),
      link: "/new-center",
      customer: false
    },
    {
      component: lazy(() => import("./views/RoleManagement")),
      link: "/role-management",
      customer: false
    },
    {
      component: lazy(() => import("./views/PermisionManagement")),
      link: "/permision-management",
      customer: false
    },
    {
      component: lazy(() => import("./views/DefaultMessage")),
      link: "/default-message",
      customer: false
    },
    {
      component: lazy(() => import("./views/DefaultEmail")),
      link: "/default-email",
      customer: false
    }
  ]
];
